const GET_RECORD = (state, recordData) => {
  state.recordData = recordData
}

export default {
  GET_RECORD
}